import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import GroceryV2Item from './GroceryV2Item';

const SortableGroceryV2Item = ({ id, text, onRemove, onEdit, onCheck, isChecked, isOver, isSelected, onSelect, isLast, editMode }) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
        backgroundColor: isSelected ? '#e3f2fd' : 'white',
        borderRadius: '50px',
    };

    return (
        <div className="relative mb-2 sortable-item">
            <div
                ref={setNodeRef}
                style={style}
                {...attributes}
                className={`relative ${isOver ? 'z-10' : 'z-0'}`}
                onClick={(e) => {
                    e.stopPropagation();
                    onSelect();
                }}
            >
                {/* Drag handle area - only the left and right sides trigger drag */}
                <div 
                    {...listeners} 
                    className="absolute inset-0 pointer-events-none"
                >
                    <div className="absolute left-12 top-0 bottom-0 w-8 pointer-events-auto cursor-grab active:cursor-grabbing drag-handle"></div>
                </div>
                <GroceryV2Item id={id} text={text} onRemove={onRemove} onEdit={onEdit} onCheck={onCheck} isChecked={isChecked} editMode={editMode} />
                {isSelected && (
                    <div className="absolute top-0 right-0 w-4 h-4 bg-blue-500 rounded-full"></div>
                )}
            </div>
            {isOver && !isDragging && (
                <div className="absolute left-0 right-0 h-0.5 bg-blue-500 rounded" style={{
                    top: isOver === 'top' ? 0 : '100%',
                    transform: 'translateY(-50%)'
                }} />
            )}
        </div>
    );
};

export default SortableGroceryV2Item;
